import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import React from 'react'
import { useIntl } from 'react-intl'

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum',
}

interface Props {
  tier: App.LoyaltyTier
  percentile: number
}

function WrappedLoyaltyPercentileBadge({
  percentile,
  tier,
}: Props) {
  const intl = useIntl()
  return <BodyTextBlock
    variant="small"
    colour={TIER_BODY_TEXT_COLOURS[tier]}
    weight="bold"
    align="start"
    startIcon={<LoyaltyTierIcon size="S" tier={tier} />}
  >
    {intl.formatMessage({ id: 'TDkirbOvfY', defaultMessage: 'Top {percentile}% of our travellers', description: 'Loyalty percentile badge text showing user ranking' }, { percentile })}
  </BodyTextBlock>
}

export default WrappedLoyaltyPercentileBadge
